import * as React from 'react';

export interface EstateIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * EstateIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Decedent's estate. Tombstone with 'RIP' engraved.
 */
const EstateIcon: React.FunctionComponent<EstateIconProps> = ({
  className,
  size = 40,
  title = 'Estate',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M11 42 L11 18 Q11 6 24 6 Q37 6 37 18 L37 42 Z" fill="#3C3489"/>
      <text x="24" y="24" textAnchor="middle" fontFamily="serif" fontSize="9" fontWeight="700" fill="#FFFFFF" letterSpacing="1.5">RIP</text>
      <line x1="17" y1="29" x2="31" y2="29" stroke="#FFFFFF" strokeWidth="1"/>
      <line x1="17" y1="35" x2="22" y2="35" stroke="#FFFFFF" strokeWidth="1.2"/>
      <line x1="22.5" y1="35" x2="25.5" y2="35" stroke="#FFFFFF" strokeWidth="1.2"/>
      <line x1="26" y1="35" x2="31" y2="35" stroke="#FFFFFF" strokeWidth="1.2"/>
  </svg>
);

export default EstateIcon;
